import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import {
  getColumnKey,
  NoDataComponent,
  TableBodyNoReferenceCellComponent,
  TableColumn,
} from '@web/shared/ui';
import { WarehouseProductQuantityHistoryCollectionItem } from '../../models/warehouse-product-quantity-history-collection-item';
import { WarehouseProductQuantityHistoryCollectionFilter } from '../../models/warehouse-product-quantity-history-collection-filter';
import { WarehouseProductQuantityHistoryReasonTypeComponent } from '../warehouse-product-quantity-history-reason-type/warehouse-product-quantity-history-reason-type.component';
import { isNotNil } from '@web/utils';

@Component({
  selector: 'app-warehouse-product-quantity-history-list-custom-cell-template',
  imports: [
    TableBodyNoReferenceCellComponent,
    WarehouseProductQuantityHistoryReasonTypeComponent,
    NoDataComponent,
  ],
  templateUrl:
    './warehouse-product-quantity-history-list-custom-cell-template.component.html',
  styleUrl:
    './warehouse-product-quantity-history-list-custom-cell-template.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WarehouseProductQuantityHistoryListCustomCellTemplateComponent {
  /* prettier-ignore */
  public readonly column = input.required<TableColumn<WarehouseProductQuantityHistoryCollectionItem, WarehouseProductQuantityHistoryCollectionFilter>>();
  /* prettier-ignore */
  public readonly model = input.required<WarehouseProductQuantityHistoryCollectionItem>();
  /* prettier-ignore */
  protected readonly getColumnKey = getColumnKey<WarehouseProductQuantityHistoryCollectionItem>;
  protected readonly isNotNil = isNotNil;
}
